// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".delete-message_466b .name_9260 {\n  color: white;\n}", "",{"version":3,"sources":["/home/runner/work/telemetry/telemetry/ts/packages/frontend/src/component/Settings/Devices/Actions.scss","Actions.scss"],"names":[],"mappings":"AACI;EACI,YAAA;ACAR","file":"Actions.scss","sourcesContent":[".delete-message {\n    .name {\n        color: white;\n    }\n}\n",".delete-message .name {\n  color: white;\n}"]}]);
// Exports
exports.locals = {
	"delete-message": "delete-message_466b",
	"name": "name_9260"
};
module.exports = exports;
